import { render, staticRenderFns } from "./Venta.vue?vue&type=template&id=c0f59396&"
import script from "./Venta.vue?vue&type=script&lang=js&"
export * from "./Venta.vue?vue&type=script&lang=js&"
import style0 from "./Venta.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports